export const MIN_PRICE = 5 as const
